/**
 * Store 페이지 Config
 *
 * 팀별 store 페이지 설정
 */

import type { TeamSlug } from '@/app/(football)/[team]/_context/types';
import type { StorePageConfig } from '@/app/(football)/[team]/store/_context/types';

import { bluewingsConfig } from './bluewings';
import { dhcfcConfig } from './dhcfc';
import { fcanyangConfig } from './fcanyang';
import { fcseoulConfig } from './fcseoul';
import { jbfcConfig } from './jbfc';
import { steelersConfig } from './steelers';
import { uhdfcConfig } from './uhdfc';

export const storeConfig: Record<TeamSlug, StorePageConfig> = {
  fcseoul: fcseoulConfig,
  bluewings: bluewingsConfig,
  steelers: steelersConfig,
  fcanyang: fcanyangConfig,
  uhdfc: uhdfcConfig,
  dhcfc: dhcfcConfig,
  jbfc: jbfcConfig,
};
